import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad, CampoData } from '../components/';
import * as Data from '../Data';

interface IInputDataProps extends Dati.IBaseProps {
    Etichetta: any;
    Valore: Date | string | undefined;
    Righe?: number;
    ValoreInArrivo?: boolean;
    DataMinima?: Date;
    DataMassima?: Date;
    IsClearable?: boolean;
}

export class InputData extends BasePureComponent<IInputDataProps, {}> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        let etichetta: any = "";
        if (typeof (this.props.Etichetta == "string")) {
            etichetta = <label>{Trad.Trad(this.props.Etichetta)}</label>;
        } else {
            etichetta = this.props.Etichetta;
        }

        //CampoData non gestisce Scrittura ma solo Disabilitato
        return <div style={{ minHeight: 88 }} className={this.props.CSS != undefined ? this.props.CSS : ""}>
            {etichetta}
            <div className="kt-input-icon kt-input-icon--right">
                <div className="form-control">
                    <CampoData
                        Disabilitato={this.props.Scrittura != undefined ? !this.props.Scrittura : undefined}
                        ValoreInArrivo={this.props.ValoreInArrivo != undefined ? this.props.ValoreInArrivo : false}
                        Name={this.props.Name}
                        Id={this.props.Id}
                        Valore={this.props.Valore}
                        OnChange={this.props.OnChange}
                        DataMassima={this.props.DataMassima}
                        DataMinima={this.props.DataMinima}
                        IsClearable={this.props.IsClearable}
                    />
                </div>
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/InputData.tsx